// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RoleListQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type RoleListQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationRoles: Array<{
    __typename?: "OrganizationRole";
    id: string;
    name: string;
    assignmentCount: number;
    permissions: Array<{
      __typename?: "OrganizationPermission";
      id: string;
      restricted: boolean;
      view: boolean;
      modify: boolean;
      billing: boolean;
      api: boolean;
      manage: boolean;
      createWorkbooks: boolean;
    }>;
  }>;
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    name: string;
    permittedToCreateRoles: boolean;
  } | null;
};

export const RoleListDocument = gql`
  query RoleList($organizationSlug: ID!) {
    getOrganizationRoles(organizationSlug: $organizationSlug) {
      id
      name
      permissions {
        id
        restricted
        view
        modify
        billing
        api
        manage
        createWorkbooks
      }
      assignmentCount
    }
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      name
      permittedToCreateRoles
    }
  }
`;

/**
 * __useRoleListQuery__
 *
 * To run a query within a React component, call `useRoleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleListQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useRoleListQuery(
  baseOptions: Apollo.QueryHookOptions<RoleListQuery, RoleListQueryVariables> &
    ({ variables: RoleListQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RoleListQuery, RoleListQueryVariables>(
    RoleListDocument,
    options,
  );
}
export function useRoleListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoleListQuery,
    RoleListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RoleListQuery, RoleListQueryVariables>(
    RoleListDocument,
    options,
  );
}
// @ts-ignore
export function useRoleListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoleListQuery,
    RoleListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RoleListQuery, RoleListQueryVariables>;
export function useRoleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleListQuery, RoleListQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RoleListQuery | undefined,
  RoleListQueryVariables
>;
export function useRoleListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoleListQuery, RoleListQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RoleListQuery, RoleListQueryVariables>(
    RoleListDocument,
    options,
  );
}
export type RoleListQueryHookResult = ReturnType<typeof useRoleListQuery>;
export type RoleListLazyQueryHookResult = ReturnType<
  typeof useRoleListLazyQuery
>;
export type RoleListSuspenseQueryHookResult = ReturnType<
  typeof useRoleListSuspenseQuery
>;
export type RoleListQueryResult = Apollo.QueryResult<
  RoleListQuery,
  RoleListQueryVariables
>;
